import React, { useMemo } from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip, Area } from 'recharts';
import { FaInfoCircle, FaSyncAlt } from 'react-icons/fa';

const colorMap = {
  'PASS PERCENTAGE': '#16a34a',
  'BUILD STABILITY': '#3b82f6',
  'FLAKINESS': '#fbbf24',
  'TESTS': '#6366f1',
  'FAILED': '#ef4444',
  'FLAKY': '#fbbf24',
  'TEST RUNS': '#3b82f6',
  'BUILD DURATION': '#a21caf',
};

function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString();
}

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  const d = payload[0].payload;
  return (
    <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 8, padding: 10, fontSize: 13, boxShadow: '0 2px 8px #0002', color: '#222' }}>
      <div><b>Date:</b> {d.date || d.x}</div>
      <div><b>Value:</b> {d.y}</div>
    </div>
  );
};

const MetricCard = React.memo(function MetricCard({ label, value, trend, chart }) {
  // Accept chart as array of numbers or array of {y, date}
  const chartData = useMemo(() => {
    if (!chart) return [];
    if (typeof chart[0] === 'object' && chart[0] !== null && 'y' in chart[0]) return chart;
    return chart.map((y, i) => ({ y, x: i }));
  }, [chart]);
  const lastDate = useMemo(() => {
    if (!chartData.length) return null;
    const last = chartData[chartData.length - 1];
    return last && last.date ? formatDate(last.date) : null;
  }, [chartData]);
  const color = colorMap[label] || '#3b82f6';
  return (
    <div className="metric-card-v2 metric-card-modern">
      <div className="metric-card-header metric-card-header-modern">
        <span className="metric-card-label metric-card-label-modern">{label} <FaInfoCircle className="metric-info-icon" /></span>
        <ResponsiveContainer width="44%" height={44}>
          <LineChart data={chartData} margin={{ top: 8, right: 0, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id={`area-${label}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.22} />
                <stop offset="95%" stopColor={color} stopOpacity={0.01} />
              </linearGradient>
            </defs>
            <Area type="monotone" dataKey="y" stroke="none" fill={`url(#area-${label})`} isAnimationActive={true} />
            <Line type="monotone" dataKey="y" stroke={color} strokeWidth={2.5} dot={{ r: 2, fill: color, stroke: '#fff', strokeWidth: 1 }} isAnimationActive={true} />
            <Tooltip content={<CustomTooltip />} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="metric-card-value-row metric-card-value-row-modern">
        <span className="metric-card-value metric-card-value-modern">{value}</span>
      </div>
      <div className="metric-card-trend-row metric-card-trend-row-modern">
        <span className="metric-card-trend metric-card-trend-modern"><FaSyncAlt className="metric-trend-icon" /> {trend} <span className="metric-card-trend-label metric-card-trend-label-modern">last run</span></span>
      </div>
      {lastDate && <div style={{ fontSize: 13, color: '#888', marginTop: 2 }}>Last run: {lastDate}</div>}
    </div>
  );
});

export default MetricCard; 